var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: 20,
    height: 20,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M549.655 124.083c-6.281-23.699-24.862-42.393-48.352-49.284C455.843 64 288 64 288 64s-167.843 0-213.303 10.799c-23.49 6.891-42.071 25.585-48.352 49.284C16 171.915 16 256 16 256s0 84.085 10.345 131.917c6.281 23.699 24.862 42.393 48.352 49.284C120.157 448 288 448 288 448s167.843 0 213.303-10.799c23.49-6.891 42.071-25.585 48.352-49.284C560 340.085 560 256 560 256s0-84.085-10.345-131.917zM232 336V176l144 80-144 80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.cc9585960fa17fc695677dec0412768b.svg";
export { ForwardRef as ReactComponent };